import React, { useEffect, useState } from "react";
import { Row, Col, Select, Spin, Badge } from "antd";
import { Link } from "react-router-dom";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { GetTypeQuestionApi } from "api/getQuiz";
import { errorHandle } from "../../../Function";
import "./ViewDocument.css";
// import ModalCreateQuiz from "./ModalQuiz/ModalCreateQuiz";
import { FileAddOutlined } from "@ant-design/icons";
import ModalCreateDoc from "./ModalDocument/ModalCreateDoc";
import { getListExamMaterialsURL } from "api/ismsApi";
import ShowImageISMS from "containers/component/Chamcong/Isms/ShowImageISMS";
import undraw_security from "../../../images/undraw_security.svg";
import ModalDelDoc from "./ModalDocument/ModalDelDoc";


const ViewDocument = () => {
  const [loading, setLoading] = useState(false);
  const [loading_page, setLoading_page] = useState(false);
  const [arrTypeQuestion, setArrTypeQuestion] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isShowCreateDoc, setIsShowCreateDoc] = useState(false);
  const [listBinaryImage, setListBinaryImage] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isShowDelDoc, setIsShowDelDoc] = useState(false);

  const fetchListExamMaterials = (params = {}) => {
    setLoading_page(true);
    getListExamMaterialsURL({ question_type: params.question_type })
      .then((res) => {
        setListBinaryImage(res.data.results);
        setLoading_page(false);
      })
      .catch((err) => {
        setLoading_page(false);
      });
  };

  const fetchTypeQs = (params = {}) => {
    setLoading(true);
    GetTypeQuestionApi(params)
      .then((res) => {
        setArrTypeQuestion(res.data.results);
        setSelectedGroup(res.data.results[0]["id"]);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchTypeQs();
  }, []);

  useEffect(() => {
    setCurrentIndex(0);
    fetchListExamMaterials({
      question_type: selectedGroup,
    });
  }, [selectedGroup]);

  const onChangeGroup = (value) => {
    setSelectedGroup(value);
  };

  const onCancelCreateDoc = () => {
    setIsShowCreateDoc(false);
  };

  const onCancelDelDoc = () => {
    setIsShowDelDoc(false);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Tài liệu ISMS</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">ISMS</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/isms/document">Tài liệu</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <Row
          // gutter={[8, 8]}
          style={{ float: "left" }}
        >
          <Col>
            <div className="sl-group m-2">
              <Badge.Ribbon text="Nhóm" color="gray" style={{ color: "red" }}>
                <Select value={selectedGroup} onChange={onChangeGroup}>
                  {arrTypeQuestion &&
                    arrTypeQuestion.map((item, index) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.note} ({item.loai_cau_hoi})
                      </Select.Option>
                    ))}
                </Select>
              </Badge.Ribbon>
            </div>
          </Col>
          <Col>
            <Button
              ghost
              type="success"
              className={"m-2"}
              onClick={() => setIsShowCreateDoc(true)}
              icon={<FileAddOutlined />}
            >
              Tải lên tài liệu
            </Button>
          </Col>
           <Col>
            <Button
              danger
              type="danger"
              className={"m-2"}
              onClick={() => listBinaryImage && setIsShowDelDoc(true)}
              icon={<FileAddOutlined />}
            >
              Xóa tài liệu
            </Button>
          </Col>
        </Row>
      </div>
      <Spin spinning={loading_page}>
        {listBinaryImage && (
          <ShowImageISMS
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            listBinaryImage={listBinaryImage}
            undraw_security={undraw_security}
            typeSize={"middle"} //'middle' | 'large' | undefined
            messagePage={"Chưa có file tài liệu. Vui lòng tải lên."}
          />
        )}
      </Spin>
      {isShowCreateDoc && (
        <ModalCreateDoc
          open={isShowCreateDoc}
          onCancel={onCancelCreateDoc}
          arrTypeQuestion={arrTypeQuestion}
          setSelectedGroup={setSelectedGroup}
          fetchListExamMaterials={fetchListExamMaterials}
        />
      )}

      {isShowDelDoc && (
        <ModalDelDoc
          open={isShowDelDoc}
          onCancel={onCancelDelDoc}
          arrTypeQuestion={arrTypeQuestion}
          selectedGroup={selectedGroup}
          fetchListExamMaterials={fetchListExamMaterials}
          listBinaryImage={listBinaryImage}
        />
      )}


    </>
  );
};

export default ViewDocument;
